export default __webpack_public_path__ + "static/media/1.e8b41d95.jpg";